export default {
  MENU: {
    GET_ALL_MENUS: 'GET_ALL_MENUS',
    SET_APPS: 'SET_APPS',
    ADD_MENU_OPTION: 'ADD_MENU_OPTION',
    ADD_MENU: 'ADD_MENU',
    REMOVE_MENU_OPTION: 'REMOVE_MENU_OPTION',
    UPDATE_MENU_FIELD: 'UPDATE_MENU_FIELD',
    SET_A_MENU: 'SET_A_MENU',
    EDIT_MENU: 'EDIT_MENU',
    EDIT_MENU_OPTION: 'EDIT_MENU_OPTION'
  },
  GENERAL: {
    LOAD_LANGUAGES: 'LOAD_LANGUAGES',
    LOAD_APPS: 'LOAD_APPS',
    LOAD_KEYWORDS: 'LOAD_KEYWORDS'
  },
  NUDGE: {
    ADD_MESSAGE: 'ADD_MESSAGE',
    REMOVE_MESSAGE: 'REMOVE_MESSAGE',
    QUERY_RESULT: 'QUERY_RESULT',
    RESULT_MESSAGE: 'RESULT_MESSAGE',
    LOAD_NUDGES: 'LOAD_NUDGES',
    LOAD_A_NUDGE_STATS: 'LOAD_A_NUDGE_STATS'
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/mutation-types.js